(function (factory) {
    var moduleName = "logoProgram";

    if (typeof ccs_define === "function") {
        ccs_define(moduleName, ["jquery"], factory);
        return;
    }

    var moduleExport = factory(window.ccsJq);
    if (typeof moduleExport !== "undefined") {
        window[moduleName] = moduleExport;
    }
}
    (function ($) {

        var c = {
            addToCartSelector: "[data-logo-addtocart]",
            qtySpanSelector: ".ccs-logo-quantity",
            eventDataAttr: "data-logo-event",
            eventParamsData: "logo-event-params",
            productIdAttr: "data-logo-productid",
            qtyGlobalVariablePrefix: "cclpQuantity",
            productLinkSelector: "[data-logo-productlink]",
            atcShownClass: "ccs-logo-atc-shown",
            linkShownClass: "ccs-logo-link-shown",
            processedFlag: "ccsLogoProcessed",

            price: {
                elementSelector: "span[data-logo-dynamic-price]",
                getPriceSelector: "a[data-logo-getprice]",
                priceUrlAttr: "data-logo-price-url",
                parsingPriceJsAttr: "data-logo-price-parsingjs",
                runImmediatelyAttr: "data-logo-price-runimmediately",
                errorLogCallAttr: "data-logo-price-error",
                fallbackTextAttr: "data-logo-price-fallback-text",
                showIfPriceAttr: "data-logo-show-if-price",
                loadingClass: "ccs-logo-price-loading"
            }
        };

        //#region events feature

        function scanEvents(entryId) {
            var $entry = $("#" + entryId);

            $entry.on("ccsPrice.init ccsPrice.success", function (e) {
                var $el = $(e.target);

                var atcIfPriceExists = $el.is("[" + c.price.showIfPriceAttr + "~=atc]");

                var ns = e.namespace;

                if (!atcIfPriceExists && ns === "init" || atcIfPriceExists && ns === "success")
                    enableAddToCart($entry, $el);
            });

            $entry.on("ccsPrice.init ccsPrice.success", function (e) {
                var $el = $(e.target);

                var linkIfPriceExists = $el.is("[" + c.price.showIfPriceAttr + "~=link]");

                var ns = e.namespace;

                if (!linkIfPriceExists && ns === "init" || linkIfPriceExists && ns === "success")
                    enableProductLink($entry, $el);
            });

            $entry.on("ccsPrice.error", function (e) {
                var $el = $(e.target);

                var fallbackText = $el.attr(c.price.fallbackTextAttr);

                if (fallbackText) {
                    $el.text(fallbackText);
                } else {
                    $el.find("." + c.price.loadingClass).hide();
                }
            });

            $entry.find(c.price.elementSelector).trigger("ccsPrice.init");
        }

        function enableAddToCart($entry, $priceElement) {
            var elementId = $priceElement.attr(c.productIdAttr);

            var $elementAtc = $entry.find(c.addToCartSelector + "[" + c.productIdAttr + "='" + elementId + "']").children();
            var $elementQty = $entry.find(c.qtySpanSelector + "[" + c.productIdAttr + "='" + elementId + "']");

            if ($elementAtc.length === 0 || $elementAtc.data(c.processedFlag))
                return;

            $elementAtc.closest(c.addToCartSelector).addClass(c.atcShownClass);
            $elementQty.closest(c.qtySpanSelector).addClass(c.atcShownClass);

            $elementAtc
                .data(c.processedFlag, true)
                .click(function () {
                    var $span = $(this).closest(c.addToCartSelector);
                    var elementId = $span.attr(c.productIdAttr);
                    var eventData = $span.attr(c.eventDataAttr);

                    var clientParams = $span.data(c.eventParamsData) || {};
                    clientParams.Qty = window[c.qtyGlobalVariablePrefix + elementId] || 1;

                    ccs_cc_log.dispatchEvent(eventData, clientParams, 100);
                });
        }

        // For MS 365 Quantity box 
        document.addEventListener("DOMContentLoaded", function () {
            document.body.addEventListener("click", function (event) {
                if (event.target.classList.contains("plus") || event.target.classList.contains("minus")) {
                    var button = event.target;
                    var change = button.classList.contains("plus") ? 1 : -1;
                    var qtyInput = button.closest(".ccs-logo-ms365-qty").querySelector("input");

                    if (!qtyInput) return;

                    var elementId = qtyInput.id.replace("quantity_", "");
                    var currentValue = parseInt(qtyInput.value) || 1;
                    var newValue = currentValue + change;

                    if (newValue < 1) newValue = 1;

                    qtyInput.value = newValue;
                    window[c.qtyGlobalVariablePrefix + elementId] = newValue;
                }
            });
        });

        function enableProductLink($entry, $priceElement) {
            var elementId = $priceElement.attr(c.productIdAttr);

            var $element = $entry.find(c.productLinkSelector + "[" + c.productIdAttr + "='" + elementId + "'] a");

            if ($element.length === 0 || $element.data(c.processedFlag))
                return;

            $element
                .attr("href", $element.attr("data-href"))
                .removeAttr("data-href");

            var title = $element.attr("data-title");

            if (title) {
                $element
                    .attr("title", title)
                    .removeAttr("data-href");
            }

            $element.addClass(c.linkShownClass);

            $element
                .data(c.processedFlag, true)
                .click(function () {
                    var $span = $(this).closest(c.productLinkSelector);
                    var eventData = $span.attr(c.eventDataAttr);
                    var clientParams = $span.data(c.eventParamsData) || {};

                    ccs_cc_log.dispatchEvent(eventData, clientParams, 100);
                });
        }

        //#endregion

        //#region dynamic price feature

        function scanPriceFeatures(entryId) {
            var $entry = $("#" + entryId);

            $entry
                .find(c.price.elementSelector)
                .filter(function () {
                    return !$(this).data(c.processedFlag);
                })
                .data(c.processedFlag, true)
                .each(function () {
                    var $priceElement = $(this);

                    var priceUrl = $priceElement.attr(c.price.priceUrlAttr);
                    var parsingJs = $priceElement.attr(c.price.parsingPriceJsAttr);
                    var errorLogCall = $priceElement.attr(c.price.errorLogCallAttr);

                    var callback = function(e) {
                        var result = (e.result || "").trim();

                        if (result) {
                            $priceElement.text(result);
                        }

                        $priceElement.trigger("ccsPrice." + (result ? "success" : "error"));
                    };

                    if ($priceElement.attr(c.price.runImmediatelyAttr)) {
                        $priceElement.find("." + c.price.loadingClass).show();
                        requestPrice(callback, priceUrl, parsingJs, errorLogCall);
                    } else {
                        $priceElement.on("click", c.price.getPriceSelector,
                            function () {
                                $priceElement.find("." + c.price.loadingClass).show();
                                $(this).remove();
                                requestPrice(callback, priceUrl, parsingJs, errorLogCall);
                            });
                    }
                });
        }

        function requestPrice(callback, priceUrl, parsingJs, errorLogCall, errorClientParams) {
            if (!callback || !priceUrl || !parsingJs) {
                throw new Error('Can\'t request price: missing function argiments.');
            }

            var errorEventInfo = errorLogCall
                ? {
                    logCall: errorLogCall,
                    actionContext: { type: "dynamicPrice", priceUrl: priceUrl }
                }
                : null;

            var ajaxRequest = {
                url: priceUrl,
                dataType: "text", // We expect text response only.
                xhr: function () {
                    var xhr = $.ajaxSettings.xhr();
                    var setRequestHeader = xhr.setRequestHeader;
                    xhr.setRequestHeader = function(name, value) {
                        if (name === "X-Requested-With")
                            return;

                        setRequestHeader.call(this, name, value);
                    };
                    return xhr;
                },
                success: function (response) {
                    grabPriceRecursive(response, callback, parsingJs, errorEventInfo);
                },
                error: function (e, ajaxStatus, httpStatus) {
                    if (errorEventInfo && ajaxStatus !== "abort" && ajaxStatus !== "timeout") { //Network problem or page reload are not dynamic pricing problems
                        dispatchDynamicPriceEvent(
                            errorEventInfo.logCall,
                            $.extend(
                                errorEventInfo.actionContext,
                                {
                                    errorType: "ajax",
                                    httpCode: e.status, // renamed to ajaxCode TODO: remove httpCode after transition period.
                                    ajaxCode: e.status,
                                    ajaxStatus: ajaxStatus,
                                    httpStatus: httpStatus
                                }),
                            errorClientParams);
                    }

                    callback({ error: e });
                }
            };

            if ($.isFunction(window.css_request_price_filter)) {
                window.css_request_price_filter(ajaxRequest);
            }

            $.ajax(ajaxRequest);
        }

        function grabPriceRecursive(response, callback, parsingJs, errorEventInfo) {
            try {
                var json = tryConvert(response, JSON.parse);
                var $html = tryConvert(response, $);

                var parsingPriceFunc = new Function("$", "raw", "$html", "json", parsingJs);
                var result = parsingPriceFunc($, response, $html, json);

                if (result && result.promise) {
                    result.done(function (resp) {
                        grabPriceRecursive(resp, callback, parsingJs, errorEventInfo);
                    });
                } else {
                    var resultType = typeof result;
                    if (resultType === "number") {
                        result = "" + result;
                    } else if (resultType !== "string") {
                        result = "";
                    }

                    if (errorEventInfo && $.trim(result) === "") {
                        dispatchDynamicPriceEvent(
                            errorEventInfo.logCall,
                            $.extend(
                                errorEventInfo.actionContext,
                                {
                                    errorType: "emptyResult"
                                }));
                    }

                    callback({ result: result });
                }
            } catch (e) {
                if (errorEventInfo) {
                    dispatchDynamicPriceEvent(
                        errorEventInfo.logCall,
                        $.extend(
                            errorEventInfo.actionContext,
                            {
                                errorType: "parsingException",
                                exception: e.name
                            }));
                }

                callback({ error: e });
                throw e;
            }
        }

        function tryConvert(response, convertFunc) {
            try {
                return convertFunc($.trim(response));
            } catch (e) {
                return null;
            }
        }

        function dispatchDynamicPriceEvent(eventData, actionContext, additionalEventParams) {
            if (!eventData) {
                return;
            }

            var newContext = actionContext;

            var stringValue = ccs_cc_log.getEventParams(eventData)["ActionContext"];
            if (stringValue) {
                var serverContext = JSON.parse(stringValue);
                newContext = $.extend({}, serverContext, actionContext);
            }

            var eventClientParams = { Et: "Submit", Action: "error", ActionContext: JSON.stringify(newContext) };

            if (additionalEventParams) {
                eventClientParams = $.extend(eventClientParams, additionalEventParams);
            }

            ccs_cc_log.dispatchEvent(eventData, eventClientParams);
        }

        //#endregion

        function detectFeatures(entryId) {
            scanEvents(entryId);
            scanPriceFeatures(entryId);
        }



        $(document).off("ccs.logo-shown").on("ccs.logo-shown", function (e, eventInfo) {
            detectFeatures(eventInfo.entryId);
        });

        var logoProgram = {
            detectFeatures: detectFeatures,
            scanEvents: scanEvents,
            requestPrice: requestPrice
        };

        return window.CcsLogoProgram = logoProgram;

    }));
